(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ablyea-campaign-banner-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'ablyea-campaign-banner-v21';
  if (customElements.get(tag)) return;
  class CampaignBanner extends HTMLElement {
    connectedCallback() {
      this.editor = this.dataset.editor === 'true' || !!window.Shopify?.designMode;
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.mutations?.disconnect();
      this.mutations = new MutationObserver(records => {
        if (records.some(r => r.type === 'attributes' || [...r.addedNodes,...r.removedNodes].some(n => n.nodeType === 1))) this.schedule();
      });
      this.mutations.observe(this,{childList:true,subtree:true,attributes:true,attributeFilter:['data-date','data-time','data-zone','data-expiry']});
      window.addEventListener('resize',()=>this.schedule(),{signal,passive:true});
      document.addEventListener('visibilitychange',()=>{
        if(document.hidden){clearInterval(this.interval);this.interval=null;}
        else this.schedule();
      },{signal});
      this.schedule();
      if(!this.editor && this.dataset.motion==='true' && !matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window){
        this.intersection?.disconnect();
        this.intersection = new IntersectionObserver(entries=>{
          if(!entries.some(e=>e.isIntersecting))return;
          this.intersection.disconnect();
          // Content is never hidden waiting for an observer or image decode.
          const layout=this.querySelector('.abh-layout');
          if(layout?.animate)this.animation=layout.animate([{transform:'translateX(-16px)'},{transform:'translateX(0)'}],{duration:400,easing:'ease-out'});
        });
        this.intersection.observe(this);
      }
    }
    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame=requestAnimationFrame(()=>this.refresh());
    }
    refresh() {
      if(!this.isConnected)return;
      if(this.dataset.fullBleed==='true'){
        const width=document.documentElement.clientWidth;
        this.style.setProperty('--abh-viewport',width+'px');
        this.style.marginLeft='0px';
        this.style.marginLeft=(-this.getBoundingClientRect().left)+'px';
      } else {this.style.removeProperty('--abh-viewport');this.style.removeProperty('margin-left');}
      this.clocks=Array.from(this.querySelectorAll('[data-abh-countdown]')).map(el=>({el,end:this.parseEnd(el.dataset.date,el.dataset.time,el.dataset.zone)}));
      this.tick();
      clearInterval(this.interval);this.interval=null;
      if(!document.hidden && this.clocks.some(c=>Number.isFinite(c.end) && c.end>Date.now()))this.interval=setInterval(()=>{
        this.tick();
        if(!this.clocks.some(c=>Number.isFinite(c.end) && c.end>Date.now())){clearInterval(this.interval);this.interval=null;}
      },1000);
    }
    parseEnd(date, time, zone) {
      const dm = (date || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
      const tm = (time || '').trim().match(/^(\d{2}):(\d{2})(?::(\d{2}))?$/);
      if (!dm || !tm) return NaN;
      const parts = [+dm[1],+dm[2],+dm[3],+tm[1],+tm[2],+(tm[3] || 0)];
      const [y,m,d,h,mi,s] = parts;
      if(y<2000 || m<1 || m>12 || d<1 || d>new Date(Date.UTC(y,m,0)).getUTCDate() || h>23 || mi>59 || s>59) return NaN;
      const wanted = Date.UTC(y,m-1,d,h,mi,s);
      try {
        const fmt = new Intl.DateTimeFormat('en-GB',{timeZone:zone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
        const wall = stamp => {
          const p = Object.fromEntries(fmt.formatToParts(new Date(stamp)).map(x=>[x.type,x.value]));
          return Date.UTC(+p.year,+p.month-1,+p.day,+p.hour,+p.minute,+p.second);
        };
        let result = wanted;
        for(let i=0;i<4;i++) result += wanted-wall(result);
        // Reject nonexistent local times during a DST spring jump.
        return wall(result) === wanted ? result : NaN;
      } catch (_) {return NaN;}
    }
    tick() {
      for (const {el,end} of this.clocks || []) {
        const clock = el.querySelector('.abh-clock');
        const message = el.querySelector('.abh-ended');
        const note = el.querySelector('.abh-editor-note');
        const editor = this.editor || !!note;
        const valid = Number.isFinite(end);
        const remaining = valid ? Math.max(0,Math.ceil((end-Date.now())/1000)) : 0;
        const ended = valid && remaining === 0;
        el.hidden = !editor && (!valid || (ended && el.dataset.expiry === 'hide'));
        clock.hidden = !editor && (!valid || (ended && el.dataset.expiry !== 'zero'));
        message.hidden = !ended || el.dataset.expiry !== 'message';
        if(note){
          note.hidden = valid && !ended;
          note.textContent = !valid ? '日期无效或该当地时间不存在。请填写日期 YYYY-MM-DD、时间 HH:MM，并选择时区。下方/上方零值仅供样式预览。' : ended ? '截止时间已过：编辑器保留零值方便调整样式，正式页面按所选到期行为显示。' : '';
        }
        const values = {days:Math.floor(remaining/86400),hours:Math.floor(remaining%86400/3600),minutes:Math.floor(remaining%3600/60),seconds:remaining%60};
        el.querySelectorAll('[data-unit]').forEach(node => {const value=String(values[node.dataset.unit]).padStart(2,'0');if(node.textContent!==value){node.textContent=value;node.style.setProperty('--cd-digit-scale',String(Math.min(1,2/value.length)));}});
      }
    }

    disconnectedCallback(){
      cancelAnimationFrame(this.frame);
      clearInterval(this.interval);this.interval=null;
      this.controller?.abort();
      this.mutations?.disconnect();
      this.intersection?.disconnect();
      this.animation?.cancel();
    }
  }
  customElements.define(tag,CampaignBanner);
  // Shopify section replacement and block selection also refresh existing instances.
  for(const event of ['shopify:section:load','shopify:block:select','shopify:section:select']){
    document.addEventListener(event,e=>{
      const root=e.target;
      root.closest?.(tag)?.schedule();
      root.querySelectorAll?.(tag).forEach(el=>el.schedule());
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ablyea-halloween-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'ablyea-halloween-banner-v1';
  if (customElements.get(tag)) return;
  class AblyeaHalloweenBanner extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if (!this.isConnected || this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.animations = [];
      this.clocks = Array.from(this.querySelectorAll('[data-abh-countdown]')).map(el => ({el, end:this.parseEnd(el.dataset.end)}));
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.ready = false;
      this.inView = false;
      this.armed = true;
      this.motion = this.dataset.motion === 'true' && typeof this.animate === 'function';
      if (this.motion && !this.reduced.matches) this.classList.add('abh-wait');
      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches) { this.classList.remove('abh-wait'); this.animations.forEach(a => a.cancel()); }
      }, {signal});
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          if (!entry.isIntersecting) { this.inView = false; this.armed = true; }
          else if (entry.intersectionRatio >= 0.1) { this.inView = true; this.play(); }
        }, {threshold:[0,0.1]});
        this.observer.observe(this);
      } else { this.inView = true; }
      const finishReady = () => {
        if (signal.aborted || this.ready) return;
        this.ready = true;
        clearTimeout(this.loadTimeout);
        this.play();
        this.classList.remove('abh-wait');
      };
      const img = this.querySelector('.abh-background img');
      const decode = () => {
        if (img && typeof img.decode === 'function') img.decode().catch(() => {}).then(finishReady);
        else finishReady();
      };
      // Fail open on slow or broken images so the offer remains usable.
      this.loadTimeout = setTimeout(finishReady, 4000);
      if (!img || img.complete) decode();
      else { img.addEventListener('load', decode, {once:true,signal}); img.addEventListener('error', finishReady, {once:true,signal}); }
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.tick(); }, {signal});
    }
    parseEnd(value) {
      const text = (value || '').trim();
      const match = text.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/);
      if (!match) return NaN;
      const [,y,m,d,h,min,sec,zone] = match;
      if (+m < 1 || +m > 12 || +d < 1 || +d > new Date(Date.UTC(+y,+m,0)).getUTCDate() || +h > 23 || +min > 59 || +sec > 59) return NaN;
      if (zone !== 'Z' && (+zone.slice(1,3) > 14 || +zone.slice(4) > 59 || (+zone.slice(1,3) === 14 && +zone.slice(4) !== 0))) return NaN;
      return Date.parse(text);
    }
    tick() {
      for (const {el,end} of this.clocks || []) {
        const clock = el.querySelector('.abh-clock');
        const message = el.querySelector('.abh-ended');
        const error = el.querySelector('.abh-date-error');
        if (!Number.isFinite(end)) {
          if (error) { error.hidden = false; clock.hidden = true; } else el.hidden = true;
          continue;
        }
        const remaining = Math.max(0, Math.ceil((end-Date.now())/1000));
        const ended = remaining === 0;
        el.hidden = ended && el.dataset.expiry === 'hide';
        clock.hidden = ended;
        message.hidden = !ended;
        const values = {days:Math.floor(remaining/86400),hours:Math.floor(remaining%86400/3600),minutes:Math.floor(remaining%3600/60),seconds:remaining%60};
        el.querySelectorAll('[data-unit]').forEach(node => {
          const value = String(values[node.dataset.unit]).padStart(2,'0');
          if (node.textContent !== value) node.textContent = value;
        });
      }
    }
    play() {
      if (!this.ready || !this.inView || !this.armed) return;
      this.armed = false;
      this.classList.remove('abh-wait');
      if (!this.motion || this.reduced.matches) return;
      this.animations.forEach(a => a.cancel());
      this.animations = [];
      const options = {duration:500,easing:'cubic-bezier(.22,.61,.36,1)',fill:'none'};
      this.querySelectorAll('.abh-layout').forEach(el => {
        if (getComputedStyle(el).display !== 'none') this.animations.push(el.animate([{opacity:0,transform:'translateX(-28px)'},{opacity:1,transform:'translateX(0)'}],options));
      });
      const background = this.querySelector('.abh-background');
      if (background) this.animations.push(background.animate([{transform:'scale(1.045)'},{transform:'scale(1)'}],options));
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      clearTimeout(this.loadTimeout);
      clearInterval(this.interval);
      this.animations?.forEach(a => a.cancel());
      this.classList.remove('abh-wait');
    }
  }
  customElements.define(tag, AblyeaHalloweenBanner);
})();


  } catch(e) { console.error(e); }
})();
})();
